import { Component } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { CustomerService } from '../../services/customer.service';
import { environment } from '../../../environments/environment';
import { CurrentService } from '../../services/current.service';
import { ProcessQuoteService } from '../../services/process-quote.service';
import { PrintService } from '../../services/print.service';
import { TranslateService } from '@ngx-translate/core';
import { DatasService } from '../../services/datas.service';
import { ClosetDoorsStandardService } from '../../services/configurators-2d/applications/closet-doors-standard.service';
import { CONFIG_CONTEXT } from 'src/app/enum/config-context.enum';

@Component({
  selector: 'ng-casto-closet-doors-quote',
  templateUrl: './closet-doors-quote.component.html',
})
export class ClosetDoorsQuoteComponent {
  public flattenBom: any;
  public products: any;
  public productList: any;
  public price: any;
  public productTotalPV: number;
  public productTotalTVA: number;
  public productTotalEcotax: number;

  public customerInfos: any;
  public projectName: string;

  public vendorEnvironment: boolean;
  public projectIsSaved: boolean;
  public printLoading: boolean;
  public quoteSystem: string = 'NC';

  constructor(
    public modalService: ModalService,
    public datas: DatasService,
    public customer: CustomerService,
    public processQuote: ProcessQuoteService,
    public current: CurrentService,
    public closetDoorsService: ClosetDoorsStandardService,
    private print: PrintService,
    private translate: TranslateService
  ) {
    this.customerInfos = {
      name: customer.isLogged ? customer.fullName : '(non identifié)',
      id: customer.isLogged ? customer.userDatas.id : '-',
    };

    this.vendorEnvironment = environment.vendor;
    this.projectIsSaved = current.HBMProject;

    if (environment.vendor) {
      let _rightNow = new Date();
      let currentYYYYMMDD: number = parseInt(_rightNow.toISOString().slice(0, 10).split('-').join(''));
      let storeSwitchDate: number = parseInt(this.current.vendor.store.switchDate);
      this.quoteSystem = currentYYYYMMDD < storeSwitchDate ? 'LegacyCommerce' : '.COM+';
    }
    let isFR = translate.getBrowserLang().substring(0, 2) == 'fr';
    this.customer.context = CONFIG_CONTEXT.CLOSET_DOORS_STANDARD;

    this.products = [];
    this.productList = [];

    let project = modalService.currentDatas.project;

    this.current.HBMProject = {
      name: project.name,
      date: project.creationDate,
    };

    let doorTypes = this.groupBy(project.doors, x => x.doorTypeId);

    this.productList = Array.from(doorTypes.keys()).map(x => {
      let products = this.convertToQuotationProduct(doorTypes.get(x), isFR);
      let url = doorTypes.get(x)[0].doorTypePicture;
      return {
        key: x,
        name: isFR ? doorTypes.get(x)[0].nameDoorTypeFr : doorTypes.get(x)[0].nameDoorTypeEn,
        products: products,
        subTotal: products.reduce((acc, cur) => acc + cur.totalPrice, 0),
        thumbnailURLSmall: url == '' || url == null ? undefined : this.closetDoorsService.apiUrl + url,
      };
    });

    if (project.baseboardCompensatorEAN) {
      this.productList.push({
        key: 0,
        name: 'Accessoires',
        products: [
          {
            ean: project.baseboardCompensatorEAN,
            reference: project.baseboardCompensatorEAN,
            name: project.baseboardCompensatorName,
            price: {
              current: { value: project.baseboardCompensatorPV },
              ecotax: { value: project.baseboardCompensatorEcotax * project.baseboardCompensatorQty },
            },
            totalPrice: project.baseboardCompensatorPV * project.baseboardCompensatorQty,
            quantity: project.baseboardCompensatorQty,
            thumbnailURLSmall:
              project.baseboardCompensatorPicture == '' || project.baseboardCompensatorPicture == null
                ? undefined
                : this.closetDoorsService.apiUrl + project.baseboardCompensatorPicture,
          },
        ],
        subTotal: project.baseboardCompensatorPV * project.baseboardCompensatorQty,
        thumbnailURLSmall: null,
      });
    }

    /*this.productList.splice(0, 0, {
      key: 0,
      name: 'Rail',
      products: [{
          ean: project.railEAN,
          reference: project.railEAN,
          name: isFR ? project.railNameFr : project.railNameEn,
          price: {
            current: { value: project.railPV },
            ecotax: { value: project.railEcotax }
          },
          totalPrice: project.railPV,
          quantity: 1,
          thumbnailURLSmall: project.railPicture == "" || project.railPicture == null ? undefined : this.closetDoorsService.apiUrl + project.railPicture
        }],
        subTotal: project.railPV,
        thumbnailURLSmall: project.commonRailPicture == "" || project.commonRailPicture == null ? undefined : this.closetDoorsService.apiUrl + project.commonRailPicture
    });*/

    this.productTotalPV = project.totalPV;
    this.productTotalTVA = project.totalPV - project.totalHT;
    this.productTotalEcotax = project.ecotax;

    this.printList();
  }

  convertToQuotationProduct(doors: Array<any>, isFR: boolean) {
    let eans = this.groupBy(doors, d => d.codeEAN);
    let products = Array.from(eans.keys()).map(key => {
      let url = eans.get(key)[0].colorPicture;
      return {
        ean: key,
        reference: key,
        name: isFR ? eans.get(key)[0].nameDoorFr : eans.get(key)[0].nameDoorEn,
        price: {
          current: { value: eans.get(key)[0].doorPV },
          ecotax: { value: eans.get(key).reduce((acc: number, cur) => acc + cur.ecotax, 0) },
        },
        totalPrice: eans.get(key).reduce((acc: number, cur) => acc + cur.doorPV, 0),
        quantity: eans.get(key).length,
        thumbnailURLSmall: url == '' || url == null ? undefined : this.closetDoorsService.apiUrl + url,
      };
    });
    let prestations = this.groupBy(doors, d => d.doorPrestationEAN);
    let others = Array.from(prestations.keys())
      .filter(k => k != null && k != undefined && k != '')
      .map(key => {
        return {
          ean: key,
          reference: key,
          name: isFR ? prestations.get(key)[0].namePrestationDoorFr : prestations.get(key)[0].namePrestationDoorEn,
          price: { current: { value: prestations.get(key)[0].doorPrestationPV } },
          totalPrice: prestations.get(key).reduce((acc: number, cur) => acc + cur.doorPrestationPV, 0),
          quantity: prestations.get(key).length,
        };
      });
    let list = [];
    products.forEach(p => list.push(p));
    others.forEach(o => list.push(o));
    return list;
  }

  printList() {
    this.printLoading = true;

    this.print.reset();
    this.print
      .addHeader(this.translate.instant('popins.products_list.print_title_' + this.customer.context))
      .then(() => {
        this.print.addText(
          this.translate.instant('popins.products_list.customer_id') + ' ' + this.customerInfos.id,
          'my-3'
        );
        this.print.addText(this.translate.instant('popins.products_list.name') + ' ' + this.customerInfos.name, 'my-3');

        this.print.addText(
          this.translate.instant('popins.products_list.project') + ' ' + this.modalService.currentDatas.project.name,
          'my-3'
        );

        this.print.addText(
          this.translate.instant('popins.products_list.dimensions') +
            ' ' +
            this.modalService.currentDatas.project.height +
            ' mm X ' +
            this.modalService.currentDatas.project.width +
            ' mm',
          'my-3'
        );
        this.print.addText(
          this.translate.instant('popins.products_list.doorNumber') +
            ' ' +
            this.modalService.currentDatas.project.doors.length,
          'my-3'
        );
        this.print.addText(
          this.translate.instant('popins.products_list.doorWidth') +
            ' ' +
            this.modalService.currentDatas.project.doorRealWidth +
            ' mm',
          'my-3'
        );

        let _dateStr = this.current.HBMProject.date.slice(0, 10).split('-');
        this.print.addText('Le ' + _dateStr[2] + '/' + _dateStr[1] + '/' + _dateStr[0], 'mt-3 mb-5');

        this.print.addDiv(document.querySelector('.price-table-container').cloneNode(true) as HTMLDivElement);

        this.print
          .addTable(document.querySelector('.table.product-table').cloneNode(true) as HTMLTableElement)
          .then(() => {
            let _legacy: string[] = this.translate
              .instant('popins.products_list.aside.closetDoorsStandardDisclaimer')
              .split('<br/>');
            this.print.addText('', 'mt-5');
            _legacy.map(p => {
              this.print.addText(p, 'my-3');
            });

            this.print.addPageBreak();
            this.print.addImage(this.modalService.currentDatas.thumb).then(() => {
              window.onafterprint = () => {
                this.modalService.close();
                window.onafterprint = () => {};
              };
              this.print.print('Devis portes de placard');
              this.printLoading = false;
            });
          });
      });
  }

  groupBy(list: Array<any>, keyGetter) {
    const map = new Map();
    list.forEach(item => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }
}
